// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__2cVWB","container":"App_container__3WLqs","loader":"App_loader__2YRt-"};